import React, {Component} from "react";
import Input from "../components/application/Input"
import PhoneNumberMask from "./PhoneNumberMask";
import ErrorSpan from "./ErrorSpan";

export default class BecomeAgentForm extends Component {
    constructor() {
        super(...arguments);

        this.fields = window.translates.agent_form;

        this.state = {
            full_name: '',
            location: '',
            phone_number: '',
            email: '',
            add_info: '',
            success: false,
            errors: {}
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.submit = this.submit.bind(this);
    }

    handleInputChange(attr, value) {
        this.setState(prevState => ({
            ...prevState,
            [attr]: value
        }))
    }

    submit() {
        const {full_name, location, phone_number, email, add_info} = this.state;
        axios.post('/gas/become-agent', {
            full_name: full_name,
            location: location,
            phone_number: phone_number,
            email: email,
            add_info: add_info,
        })
            .then((resp) => {
                this.setState({
                    success: true,
                    errors: {},
                })
            })
            .catch((error) => {
                this.setState({
                    success: false,
                    errors: error.response.data.errors || {}
                })
            })
    }

    render() {
        const {full_name, location, phone_number, email, add_info, success, errors} = this.state;

        return (
            <div>
                <button type="button" className="btn btn-warning btn-site mt-4" data-toggle="modal"
                        data-target="#agentModal">
                    {window.translates.buttons.join_agent}
                </button>
                <div className="modal fade" id="agentModal" tabIndex="-1" role="dialog"
                     aria-labelledby="agentModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="agentModalLabel">{this.fields.title}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {success ?
                                    <div>
                                        <div className="success-checkmark">
                                            <div className="check-icon">
                                                <span className="icon-line line-tip"></span>
                                                <span className="icon-line line-long"></span>
                                                <div className="icon-circle"></div>
                                                <div className="icon-fix"></div>
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <p>{this.fields.success_message}</p>
                                        </div>
                                    </div>
                                    :
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Input attr="full_name" label={this.fields.full_name}
                                                   value={full_name} required={true} error={errors.full_name}
                                                   onChange={this.handleInputChange}
                                            />
                                            <Input attr="location" label={this.fields.location}
                                                   value={location} required={true} error={errors.location}
                                                   onChange={this.handleInputChange}
                                            />
                                            <div className="form-group">
                                                <label htmlFor="phone_number">
                                                    {this.fields.phone_number}<span className="text-danger">*</span>
                                                </label>
                                                <PhoneNumberMask
                                                    attribute="phone_number"
                                                    value={phone_number}
                                                    invalid={Boolean(errors.phone_number)}
                                                    onChange={this.handleInputChange}
                                                />
                                                {errors.phone_number && <ErrorSpan error={errors.phone_number}/>}
                                            </div>
                                            <Input attr="email" label={this.fields.email}
                                                   value={email} required={true} error={errors.email}
                                                   onChange={this.handleInputChange}
                                            />
                                            <div className="form-group">
                                                <label htmlFor="add_info">{this.fields.add_info}</label>
                                                <textarea className="form-control" name="add_info" cols="3" rows="2"
                                                          value={add_info}
                                                          onChange={(e) => this.setState({add_info: e.target.value})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="modal-footer">
                                {!success &&
                                <button type="button" className="btn btn-warning btn-site"
                                        onClick={this.submit}
                                >
                                    {window.translates.buttons.join_agent}
                                </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
